import { useState, useCallback } from 'react';
import api from 'service/api';
import { useAuth } from './auth';

export const useExchanges = () => {
  const { requestIntercept } = useAuth();

  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const getJoinedStringCustomFilter = (custom_filter) => {
    let joinedCustomFilter = custom_filter
      .map((item) => item.id)
      .join('&custom_filter=');

    return (joinedCustomFilter =
      custom_filter.length > 0 ? `&custom_filter=${joinedCustomFilter}` : '');
  };

  const getJoinedStringScale = (scales) => {
    let joinedStringScales = scales.map((item) => item.id).join('&scale_id=');

    return (joinedStringScales =
      scales.length > 0 ? `&scale_id=${joinedStringScales}` : '');
  };

  const getExchanges = useCallback(async (params) => {
    try {
      setLoading(true);
      const {
        date_start,
        date_end,
        unit_id,
        page,
        per_page,
        search,
        custom_filter,
        scales,
      } = params;

      const useCustomFilter =
        custom_filter.length >= 1 && custom_filter.length <= 4;
      const effectiveFilter = useCustomFilter ? 'custom' : 'exchanges';
      const customFilterQuery = useCustomFilter
        ? getJoinedStringCustomFilter(custom_filter)
        : '';

      const response = await requestIntercept(
        api.get,
        `/v2/admin/reports/exchanges?filter=${effectiveFilter}${customFilterQuery}${getJoinedStringScale(
          scales
        )}`,
        { date_start, date_end, unit_id, page, per_page, search }
      );
      if (response.status !== 200) {
        throw response;
      }
      setData(response.data.data);
      setTotal(response.data.pagination.total_items);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, []);

  return {
    loading,
    data,
    total,
    getExchanges,
  };
};
